import dayJS from 'dayjs'

/** Extract the datetime out of the 48-timeslot-hours based time
 * @param { number } selectedValue a float hour 13h30 <=> 55
 * @param { number } startHour start hour
 * @param { Date } date picted
 * @param { number } hourSegmentation how many times we split a hour
 * @param { number } timeToAdd the time in number to add to the result (input a negative number to remove it instead)
 * @param { ManipulateType } timeToAddUnit the unit of the time to remove
 * @return { string } ISO date string
 */
export function getDateTimeFromSelectValue(
  selectedValue: number,
  startHour = 8,
  date: Date = new Date(),
  hourSegmentation = 4,
  timeToAdd?: number,
  timeToAddUnit: dayJS.ManipulateType = 's'
): string {
  const firstTimeSlotIndex = startHour * hourSegmentation
  const time24HourBased =
    (selectedValue + firstTimeSlotIndex - 1) / hourSegmentation
  const minutes = 60 * (time24HourBased % 1)
  const hours = Math.floor(time24HourBased)
  const dateFormated = dayJS(date)
    .set('hour', hours)
    .set('minute', minutes)
    .set('second', 0)
    .set('millisecond', 0)
  let validDateFormatted: dayJS.Dayjs = dateFormated.isValid()
    ? dateFormated
    : dayJS(date)
  if (timeToAdd) {
    validDateFormatted = validDateFormatted.add(timeToAdd, timeToAddUnit)
  }
  return validDateFormatted.toISOString()
}
